import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=b15e3694&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=ts"
export * from "./Preloader.vue?vue&type=script&lang=ts"
import style0 from "./Preloader.vue?vue&type=style&index=0&id=b15e3694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15e3694",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
